import * as React from "react";

import Box from "@mui/material/Box";

import { styled } from "styled-components";

import {
  Button,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Modal,
  Paper,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import HomeIcon from "@mui/icons-material/Home";
import Drawer from "@mui/material/Drawer";
import WebAssetSharpIcon from "@mui/icons-material/WebAssetSharp";
import AssessmentIcon from "@mui/icons-material/Assessment";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckIcon from "@mui/icons-material/Check";
import CircleIcon from "@mui/icons-material/Circle";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DashboardIcon from "@mui/icons-material/Dashboard";
import "./header.scss";
import { updateUser } from "../actions/user";
import toast from "react-hot-toast";
import Logo from "./Logo";

import ProfileImage from "./Avatar";
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const StyleSidebar = styled.aside`
  background-color: #3d4f58;
  overflow: auto;
  grid-row: 1/-1;
  display: flex;
  flex-direction: column;
  gap: 3.2rem;
  transition: width 0.3s ease-in-out, opacity 0.3s ease-in-out;
`;
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

export default function SideBar() {
  const mode_state = useSelector((state) => state.mode);
  const [mode, setMode] = React.useState(mode_state);
  React.useEffect(() => {
    setMode(mode_state);
  }, [mode_state]);

  const [ModalOpen, setModalOpen] = React.useState(false);
  const unApprovedAssets = useSelector((state) => state.newAsset);
  const user = JSON.parse(secureLocalStorage.getItem("profile"));

  const handleOpen = () => {
    setModalOpen(true);
  };
  const handleClose = () => {
    setModalOpen(false);
  };

  let approve = false;
  if (
    user?.results.assets === "Administrator" ||
    user?.results.assets === "Approver"
  ) {
    approve = true;
  } else {
    approve = false;
  }
  const list = approve
    ? [
        {
          text: "Dashboard",
          to: "/assets-register/",
          icon: <DashboardIcon />,
        },
        {
          text: "Assets",
          to: "/assets-register/all-assets",
          icon: <WebAssetSharpIcon />,
        },
        {
          text: "Assets Report",
          to: "/assets-register/tangible-report",
          icon: <AssessmentIcon />,
        },
        {
          text: "Intangibles",
          to: "/assets-register/intangible-report",
          icon: <AssessmentIcon />,
        },
        {
          text: "Right-of-use",
          to: "/assets-register/right-of-use-report",
          icon: <AssessmentIcon />,
        },
        {
          text: "Summary Report",
          to: "/assets-register/summary-report",
          icon: <AssessmentIcon />,
        },
        {
          text: "Approvals",
          to: "/assets-register/approvals",
          icon: <CheckCircleIcon />,
        },
        {
          text: "Settings",
          to: "/assets-register/user-page",
          icon: <SettingsIcon />,
        },
      ]
    : [
        {
          text: "Dashboard",
          to: "/assets-register/",
          icon: <DashboardIcon />,
        },
        {
          text: "Assets",
          to: "/assets-register/all-assets",
          icon: <WebAssetSharpIcon />,
        },
        {
          text: "Assets Report",
          to: "/assets-register/tangible-report",
          icon: <AssessmentIcon />,
        },
        {
          text: "Intangibles",
          to: "/assets-register/intangible-report",
          icon: <AssessmentIcon />,
        },
        {
          text: "Right-of-use",
          to: "/assets-register/right-of-use-report",
          icon: <AssessmentIcon />,
        },
        {
          text: "Summary Report",
          to: "/assets-register/summary-report",
          icon: <AssessmentIcon />,
        },
        {
          text: "Settings",
          to: "/assets-register/user-page",
          icon: <SettingsIcon />,
        },
      ];
  const dispatch = useDispatch();
  const logout = () => {
    let loggingOutId;

    loggingOutId = toast.loading("Please wait we are logging you out...");
    dispatch(updateUser(user?.results._id, { login: "no", system: "none" }));
    setTimeout(() => {
      dispatch({ type: "LOGOUT" });
      navigate("/assets-register/login");
      toast.remove(loggingOutId);
    }, 2000);
  };

  const location = useLocation();
  const path = location.pathname;
  const navigate = useNavigate();
  let blinkingMessage = false;

  if (
    (user?.results.assets === "Approver" ||
      user?.results.assets === "Administrator") &&
    unApprovedAssets.length >= 1
  ) {
    blinkingMessage = true;
  } else {
    blinkingMessage = false;
  }

  return (
    <StyleSidebar sx={{ flexGrow: 1 }}>
      <Drawer
        elevation={0}
        className="drawer-asset"
        sx={{
          elevation: 0,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            backgroundColor: `${mode === "dark" ? "#101418" : "#3D4F58"}`,
            color: `${mode === "dark" ? "rgba(255,255,255,0.65)" : "#F3F3F4"}`,

            height: "100vh",
            boxSizing: "border-box",
            border: "none",

            // fontWeight: "bold",
            elevation: 0,
            marginRight: "10px",
          },
        }}
        variant="permanent"
        anchor="left"
      >
        <Toolbar
          elevation={0}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Logo />
        </Toolbar>
        <List>
          {list.map((text) => (
            <ListItem
              className={path === text.to ? "selected-item" : "unselected-item"}
              key={text.text}
              disablePadding
            >
              <ListItemButton onClick={() => navigate(text.to)}>
                <ListItemIcon
                  style={{
                    color:
                      path === text.to ? "#000000" : "rgba(255,255,255,0.65)",
                  }}
                >
                  {text.icon}
                </ListItemIcon>

                <ListItemText
                  style={{ marginLeft: "-20px" }}
                  onClick={() => navigate(text.to)}
                  primary={text.text}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>

        <Paper
          style={{
            // marginLeft: "5px",

            marginTop: "10px",
            marginBottom: "10px",
            // margin: "auto",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "5px",
            backgroundColor: "rgba(255,255,255,0.65)",
            border: `1px solid ${mode === "dark" ? "#0883FF" : "#17B859"}`,
          }}
        >
          <ProfileImage />

          <div style={{ display: "flex", flexDirection: "column" }}>
            <Typography style={{ fontSize: "10px", fontWeight: "bolder" }}>
              {user?.results.firstName + " " + user?.results.lastName}
            </Typography>
            <Typography
              style={{
                fontSize: "8px",
                marginLeft: "25%",
                backgroundColor: "#ffff",
                border: `1px solid ${mode === "dark" ? "#0883FF" : "#17B859"}`,
                borderRadius: "5px",
                padding: "2px",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <strong>Role:</strong> {user?.results.userRole}
              <CircleIcon
                className="blinking-text"
                style={{
                  fontSize: "8px",
                  color:
                    user?.results.userRole === "admin" ? "green" : "lightgreen",
                }}
              />
            </Typography>
          </div>
        </Paper>

        <Typography
          style={{
            display: "flex",
            alignItems: "center",
            paddingLeft: "5px",
            color: "rgba(255,255,255,0.65)",
          }}
        >
          <HomeIcon /> Branch: {user?.results.branch}
        </Typography>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Tooltip title="click to logout">
            <IconButton
              style={{
                backgroundColor: `${mode === "dark" ? "#0883FF" : "#17b859"}`,
              }}
              onClick={handleOpen}
            >
              <LogoutIcon style={{ color: "#fff" }} />
            </IconButton>
          </Tooltip>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "10px",
          }}
        >
          <strong>v1.3</strong>
        </div>
      </Drawer>
      {blinkingMessage && (
        <Stack spacing={2} sx={{ width: "100%" }}>
          <Snackbar
            className="blinking-text"
            open={blinkingMessage}
            autoHideDuration={6000}
          >
            <Alert severity="info">some assets needs your approval</Alert>
          </Snackbar>
        </Stack>
      )}
      <Modal
        open={ModalOpen}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={style}
          style={{ backgroundColor: "#dfdfdf" }}
          className="animate__animated animate__pulse"
        >
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Logout Confirmation
          </Typography>
          <Typography style={{ marginTop: "10px", fontWeight: "bold" }}>
            {user?.results.firstName + " " + user?.results.lastName}
          </Typography>
          <Typography
            id="modal-modal-description"
            sx={{ mt: 2, marginBottom: "20px" }}
          >
            Are You Sure You Want To Exit?
          </Typography>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Button
              style={{ backgroundColor: "#116149" }}
              onClick={logout}
              size="small"
              variant="contained"
            >
              Yes <CheckIcon />
            </Button>
            <Button
              color="error"
              className="btn-danger"
              size="small"
              onClick={handleClose}
              variant="contained"
            >
              CANCEL <CancelIcon />
            </Button>
          </div>
        </Box>
      </Modal>
    </StyleSidebar>
  );
}
